// extracted by mini-css-extract-plugin
export default {"fullViewBtn":"btn-full-view-module--full-view-btn--3M2Y9","contentContainer":"btn-full-view-module--content-container--SxNZl","icon":"btn-full-view-module--icon--31Jrd"};